import router from "../../router"
let modules={
    namespaced:true,
    state:{
        access_token:localStorage['access_token']?localStorage['access_token']:"",
        openid:localStorage['openid']?localStorage['openid']:"",
        refresh_token:localStorage['refresh_token']?localStorage['refresh_token']:"",
        isLogin:localStorage['isLogin']?Boolean(localStorage['isLogin']):false,
    },
    mutations:{
        login(state,payload){
            state.access_token=payload.access_token;
            state.openid=payload.openid;
            state.refresh_token=payload.refresh_token;
            state.isLogin=Boolean(payload.isLogin)
            localStorage['access_token']=payload.access_token;
            localStorage['openid']=payload.openid;
            localStorage['refresh_token']=payload.refresh_token;
            localStorage['isLogin']=payload.isLogin;
        },
        outLogin(state){
            state.access_token="";
            state.openid="";
            state.refresh_token="";
            state.isLogin=false;
            localStorage.removeItem("access_token");
            localStorage.removeItem("isLogin")
            localStorage.removeItem("openid")
            localStorage.removeItem("refresh_token");
            localStorage.removeItem("headimgurl");
            localStorage.removeItem("nickname");
            localStorage.removeItem("sessionid");
            localStorage.removeItem("companyName");
            localStorage.removeItem("logo");
            localStorage.removeItem("link");
            // router.push('/index')
            router.push('/login')
        }
    }
};

export default modules;
